
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('bootstrap-slider');

require('datatables');

// require('handlebars');

import 'handlebars/dist/handlebars.min.js';
import { AppHeader, AppFooter, Navbar, NavbarItem, PostIt } from "@umn-latis/cla-vue-template";



import { createApp } from 'vue'

const app = createApp({})

app.component('app-header', AppHeader);
app.component('navbar-item', NavbarItem);
app.component('navbar', Navbar);
app.component('app-footer', AppFooter);
app.component('postit', PostIt);


app.mount('#app')

const app2 = createApp({})
app2.component('app-footer', AppFooter);
app2.mount('#appfooter')